import { Component, inject, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventCategory } from '@models/event-category.model';
import { HttpClient } from '@angular/common/http';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ResetChangePasswordModalComponent } from '@app/authentication/reset-change-password-modal/reset-change-password-modal.component';
import { Overlay } from '@angular/cdk/overlay';
import { ThemeService } from '@app/services/theme.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],

    imports: [SidebarComponent, TranslocoModule, CommonModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeComponent implements OnInit {
    private subscription: Subscription | undefined;
    showBackToTopButton = false;
    IMAGES_PATH = 'assets/images/svg/';
    eventCategories: EventCategory = {} as EventCategory;
    private overlay = inject(Overlay);

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private themeService: ThemeService
    ) {}

    // @HostListener('window:scroll', [])
    onWindowScroll() {
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        const currentScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        const heightDistance = currentScrollPosition - scrollHeight;
        const scrollThreshold = currentScrollPosition * 0.4;

        if (heightDistance >= scrollThreshold) {
            this.showBackToTopButton = true;
        } else {
            this.showBackToTopButton = false;
        }
    }

    ngOnInit() {
        document.body.addEventListener('scroll', this.onWindowScroll.bind(this));

        // this.bettManagerService.fetchEventData().subscribe(
        //     {
        //         next: (data) => {
        //             this.processEventData(data);
        //         },
        //         error: (error) => console.error('Error fetching mock event data:', error),
        //     });

        //If reset password token is present, open modal
        this.route.params.subscribe({
            next: (params) => {
                if (params['token']) {
                    this.dialog.open(ResetChangePasswordModalComponent, {
                        data: { token: params['token'] },
                        scrollStrategy: this.overlay.scrollStrategies.noop(),
                    });
                }
            },
        });
    }

    processEventData(data: any[]) {
        const filteredData = data.filter((event) => event.category != null);
        const sports: Record<string, Record<string, League[]>> = {};
        const sportName = 'Soccer';
        const iconPath = this.IMAGES_PATH + 'football_logo.png';

        filteredData.forEach((event) => {
            if (!sports[sportName]) {
                sports[sportName] = {};
            }
            if (!sports[sportName][event.category]) {
                sports[sportName][event.category] = [];
            }
            sports[sportName][event.category].push({ name: event.name });
        });

        this.accordionItems = Object.entries(sports).map(([sport, countries]) => {
            const countryCount = Object.keys(countries).length;

            return {
                name: sport,
                icon: iconPath,
                count: countryCount,
                expanded: true,
                countries: Object.entries(countries).map(([countryName, leagues]) => {
                    const leagueCount = leagues.length;

                    return {
                        name: countryName,
                        count: leagueCount,
                        leagues: leagues,
                        expanded: false,
                    };
                }),
            };
        }) as AccordionItem[];
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    accordionItems: AccordionItem[] = [];

    scrollToTop() {
        document.body.scrollTo({ top: 0, behavior: 'auto' });
    }
}

interface League {
    name: string;
}

interface Country {
    count: number;
    name: string;
    leagues: League[];
    expanded: boolean;
}

interface Sport {
    count: number;
    name: string;
    icon: string;
    countries: Country[];
    expanded: boolean;
}

type AccordionItem = Sport;
